import { useAtom, atom } from 'jotai'
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { getInquiry, getCertificateDisplay } from "../../api/api";
import { isoDateToStr } from "../../api/api_util";
import { useEffect } from 'react';
import AttentionDialog from "./attention_dialog";

const isLoadingAtom = atom(false);
const inquiryCategoryAtom = atom("");
const questionAreaAtom = atom();
const attachedFileAtom = atom();
const checkBoxAtom = atom(false);
const acceptanceNumberAtom = atom();
const customerStatusAtom = atom();
const subjectAtom = atom();
const customerNameAtom = atom();
const operationTypeAtom = atom();
const modelNameAtom = atom();
const modelNumberAtom = atom();
const osNameAtom = atom();
const osVersionAtom = atom();
const relatedHardware1Atom = atom();
const relatedHardwareModelNumber1Atom = atom();
const relatedHardware2Atom = atom();
const relatedHardwareModelNumber2Atom = atom();
const relatedSoftwareAtom = atom();
const relatedSoftwareModelNumberAtom = atom();
const recordsAtom = atom([]);
const openAttentionDialogAtom = atom({ show: false, dialogId: 0 });
const EMPTY = "（未入力）";
const UNSELECT = "";


function MainComponent() {

    document.title = "継続お問い合わせ| ファーストコンタクトセンター";
    const imageUrlPopUp = require("../../images/popup.png")
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useAtom(isLoadingAtom);
    const [inquiryCategory, setInquiryCategory] = useAtom(inquiryCategoryAtom);
    const [questionArea, setQuestionArea] = useAtom(questionAreaAtom);
    const [attachedFile, setAttachedFile] = useAtom(attachedFileAtom);
    const [checkBox, setCheckBox] = useAtom(checkBoxAtom);
    const [acceptanceNumber, setAcceptanceNumber] = useAtom(acceptanceNumberAtom);
    const [customerStatus, setCustomerStatus] = useAtom(customerStatusAtom);
    const [subject, setSubject] = useAtom(subjectAtom);
    const [customerName, setCustomerName] = useAtom(customerNameAtom);
    const [operationType, setOperationType] = useAtom(operationTypeAtom);
    const [modelName, setModelName] = useAtom(modelNameAtom);
    const [modelNumber, setModelNumber] = useAtom(modelNumberAtom);
    const [osName, setOsName] = useAtom(osNameAtom);
    const [osVersion, setOsVersion] = useAtom(osVersionAtom);
    const [relatedHardware1, setRelatedHardware1] = useAtom(relatedHardware1Atom);
    const [relatedHardwareModelNumber1, setRelatedHardwareModelNumber1] = useAtom(relatedHardwareModelNumber1Atom);
    const [relatedHardware2, setRelatedHardware2] = useAtom(relatedHardware2Atom);
    const [relatedHardwareModelNumber2, setRelatedHardwareModelNumber2] = useAtom(relatedHardwareModelNumber2Atom);
    const [relatedSoftware, setRelatedSoftware] = useAtom(relatedSoftwareAtom);
    const [relatedSoftwareModelNumber, setRelatedSoftwareModelNumber] = useAtom(relatedSoftwareModelNumberAtom);
    const [records, setRecords] = useAtom(recordsAtom);
    const [openAttentionDialog, setOpenAttentionDialog] = useAtom(openAttentionDialogAtom);
    const dataCheck = ["", undefined, null, false]
    const location = useLocation();

    if (!location.state) {
        location.state = { page: "NO_DATA" };
    }

    useEffect(() => {
        if (location.state.page === "NO_DATA") {
            navigate("/inquiry_status", { state: { page: true } });
            initInput();
        }
    })

    function initInput() {
        setInquiryCategory(UNSELECT);
        setQuestionArea(UNSELECT);
        setAttachedFile(UNSELECT);
        setCustomerStatus(UNSELECT);
        setSubject(UNSELECT);
        setCustomerName(UNSELECT);
        setOperationType(UNSELECT);
        setModelName(UNSELECT);
        setModelNumber(UNSELECT);
        setOsName(UNSELECT);
        setOsVersion(UNSELECT);
        setRelatedHardware1(UNSELECT);
        setRelatedHardwareModelNumber1(UNSELECT);
        setRelatedHardware2(UNSELECT);
        setRelatedHardwareModelNumber2(UNSELECT);
        setRelatedSoftware(UNSELECT);
        setRelatedSoftwareModelNumber(UNSELECT);
        setRecords(UNSELECT)
        location.state.page = false
    }

    if (location.state.page === true) {
        initInput();
        setIsLoading(true);
        setCheckBox(false);
        let acceptNum;
        acceptNum = location.state.acceptanceNumber;
        setAcceptanceNumber(acceptNum);
        getInquiry(acceptNum).then(function (ret) {
            if (ret !== false) {
                setInquiryCategory(location.state.inquiryCategory ? location.state.inquiryCategory : "");
                setQuestionArea(location.state.questionArea ? location.state.questionArea : "");
                setAttachedFile(location.state.attachedFile ? location.state.attachedFile : "");
                setCustomerStatus(ret.common.customerStatus ? ret.common.customerStatus : EMPTY);
                setSubject(ret.common.subject ? ret.common.subject : EMPTY);
                setCustomerName(ret.common.customerName ? ret.common.customerName : EMPTY);
                setOperationType(ret.common.operationType ? ret.common.operationType : EMPTY);
                setModelName(ret.common.modelName ? ret.common.modelName : EMPTY);
                setModelNumber(ret.common.modelNumber ? ret.common.modelNumber : EMPTY);
                setOsName(ret.common.osName ? ret.common.osName : EMPTY);
                setOsVersion(ret.common.osVersion ? ret.common.osVersion : EMPTY);
                setRelatedHardware1(ret.common.relatedHardware1);
                setRelatedHardwareModelNumber1(ret.common.relatedHardwareModelNumber1 ? ret.common.relatedHardwareModelNumber1 : EMPTY);
                setRelatedHardware2(ret.common.relatedHardware2);
                setRelatedHardwareModelNumber2(ret.common.relatedHardwareModelNumber2 ? ret.common.relatedHardwareModelNumber2 : EMPTY);
                setRelatedSoftware(ret.common.relatedSoftware);
                setRelatedSoftwareModelNumber(ret.common.relatedSoftwareModelNumber ? ret.common.relatedSoftwareModelNumber : EMPTY);
                setRecords(ret.records);
            } else {
                alert("現在サーバーが込み合っているか、または、システムメンテナンス中です。時間を置いて再試行してください。")
                navigate("/inquiry_status", { state: { page: true } });
            }
            setIsLoading(false);
        });

    }
    if (location.state.page === "return") {
        setAcceptanceNumber(location.state.acceptanceNumber);
        setInquiryCategory(location.state.inquiryCategory);
        setQuestionArea(location.state.questionArea);
        setAttachedFile(location.state.attachedFile);
        setCustomerStatus(location.state.customerStatus);
        setSubject(location.state.subject);
        setCustomerName(location.state.customerName);
        setOperationType(location.state.operationType);
        setModelName(location.state.modelName);
        setModelNumber(location.state.modelNumber);
        setOsName(location.state.osName);
        setOsVersion(location.state.osVersion);
        setRelatedHardware1(location.state.relatedHardware1);
        setRelatedHardwareModelNumber1(location.state.relatedHardwareModelNumber1);
        setRelatedHardware2(location.state.relatedHardware2);
        setRelatedHardwareModelNumber2(location.state.relatedHardwareModelNumber2);
        setRelatedSoftware(location.state.relatedSoftware);
        setRelatedSoftwareModelNumber(location.state.relatedSoftwareModelNumber);
        setRecords(location.state.records)
        location.state.page = false
    }

    const handleInquiryCategoryChange = (event) => {
        setInquiryCategory(event.target.value);
    }
    const handleQuestionAreaChange = (event) => {
        setQuestionArea(event.target.value);
    }
    const handleAttachedFileChange = (event) => {
        setAttachedFile(event.target.value);
    }
    const handleCheckBoxChange = (event) => {
        setCheckBox(event.target.checked);
    }

    const toSend = () => {

        let newQuestionArea = questionArea.replace(/^\s+/g, '');
        let searchAccNum = location.state.searchAccNum;
        let searchDateFrom = location.state.searchDateFrom;
        let searchDateTo = location.state.searchDateTo;
        let searchCustomerStatusNum = location.state.searchCustomerStatusNum;
        let searchEndUser = location.state.searchEndUser;

        if (dataCheck.includes(inquiryCategory) === true) {
            alert("お問い合わせ区分をチェックしてください。");
            return;
        }
        if (dataCheck.includes(newQuestionArea) === true) {
            alert("更新内容を入力してください。");
            return;
        }
        if (dataCheck.includes(attachedFile) === true) {
            alert("添付ファイル有無をチェックしてください。");
            return;
        }
        if (dataCheck.includes(checkBox) === true) {
            alert("マイナンバーの確認にチェックしてください。");
            return;
        }
        setCheckBox("");
        navigate("/relation_inquiry_confirm", {
            state:
            {
                attachedFile,
                inquiryCategory,
                questionArea: questionArea ? questionArea.trim() : questionArea,
                acceptanceNumber,
                customerStatus,
                subject,
                customerName,
                operationType,
                modelName,
                modelNumber,
                osName,
                osVersion,
                relatedHardware1,
                relatedHardwareModelNumber1,
                relatedHardware2,
                relatedHardwareModelNumber2,
                relatedSoftware,
                relatedSoftwareModelNumber,
                searchAccNum,
                searchDateFrom,
                searchDateTo,
                searchCustomerStatusNum,
                searchEndUser,
                records
            }
        });
    }

    const goBack = () => {

        let searchAccNum = location.state.searchAccNum;
        let searchDateFrom = location.state.searchDateFrom;
        let searchDateTo = location.state.searchDateTo;
        let searchCustomerStatusNum = location.state.searchCustomerStatusNum;
        let searchEndUser = location.state.searchEndUser;

        navigate("/inquiry_status", {
            state: {
                searchAccNum,
                searchDateFrom,
                searchDateTo,
                searchCustomerStatusNum,
                searchEndUser,
                page: "return"
            }
        });
        initInput();
    }

    const handleClose = (newValue, id) => {
        setOpenAttentionDialog({ show: false });
    };

    const open_certification = async (contactId) => {
        setIsLoading(true);
        const html_body = await getCertificateDisplay(contactId);
        const win = await window.open("預り証", "_blank");
        win.document.write(html_body);
        win.document.close();
        setIsLoading(false)
    }
    const InqHistList = () => {
        if (!records) {
            if (!location.state.records) {
                return null;
            }
        }
        return records.map((rec, key) => {
            return (
                <div className="mod-tbl-form" key={key}>
                    <table role="presentation">
                        <tbody>
                            <tr>
                                <td className="caption">
                                    <div className="inner">
                                        <b>処理日時</b>
                                    </div>
                                </td>
                                <td className="caption">
                                    <div className="inner">
                                        <b>処理者</b>
                                    </div>
                                </td>
                                <td className="caption">
                                    <div className="inner">
                                        <b>アクション</b>
                                    </div>
                                </td>
                                <td className="caption">
                                    <div className="inner">
                                        <b>添付ファイル</b>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="inner">
                                        {isoDateToStr(rec.processingDateTime)}
                                    </div>
                                </td>
                                <td>
                                    <div className="inner">
                                        {rec.transactor}
                                    </div>
                                </td>
                                <td>
                                    <div className="inner">
                                        {rec.action}
                                    </div>
                                </td>
                                <td>
                                    <div className="inner">
                                        {rec.isAppendedDocument === 1 ?
                                            <Link to="/relation_inquiry_create" state={
                                                {
                                                    acceptanceNumber: acceptanceNumber,
                                                    inquiryCategory: inquiryCategory,
                                                    questionArea: questionArea,
                                                    attachedFile: attachedFile,
                                                    customerStatus: customerStatus,
                                                    subject: subject,
                                                    customerName: customerName,
                                                    operationType: operationType,
                                                    modelName: modelName,
                                                    modelNumber: modelNumber,
                                                    osName: osName,
                                                    osVersion: osVersion,
                                                    relatedHardware1: relatedHardware1,
                                                    relatedHardwareModelNumber1: relatedHardwareModelNumber1,
                                                    relatedHardware2: relatedHardware2,
                                                    relatedHardwareModelNumber2: relatedHardwareModelNumber2,
                                                    relatedSoftware: relatedSoftware,
                                                    relatedSoftwareModelNumber: relatedSoftwareModelNumber,
                                                    records: records,
                                                    searchAccNum: location.state.searchAccNum,
                                                    searchDateFrom: location.state.searchDateFrom,
                                                    searchDateTo: location.state.searchDateTo,
                                                    searchCustomerStatusNum: location.state.searchCustomerStatusNum,
                                                    searchEndUser: location.state.searchEndUser,
                                                    page: "return"
                                                }
                                            } onClick={() => open_certification(rec.contactId)} >"あり"</Link>
                                            : "なし"
                                        }
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td className="caption" colSpan="4">
                                    <div className="inner">
                                        <b>内容</b>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan="4">
                                    <div className="inner">
                                        <div className="text-pre-wrap">{rec.body}</div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            );
        });
    }

    return (
        <div className="ls-row str-column-main" id="ls-row-3-col-1-row-2-col-2-row-1">
            {isLoading === true ?
                <>
                    <div>
                        <div className='overlay-relation'></div>
                        <div className="loader-block-relation ">
                            <div className='lds-roller'>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                            <div className="loader-text">Loading...</div>
                        </div>
                    </div >
                </>
                : null}
            <div className="str-outer">
                <div className="str-inner">
                    <div className="mod-hdg-l1">
                        <div className="inner">
                            <h1 className="hdg">Web問い合わせシステム</h1>
                            <span className="sub of-top">NEC ファーストコンタクトセンター</span>
                        </div>
                    </div>
                    <h2 className="mod-hdg-l2-02">
                        <span>継続お問い合わせ</span>
                    </h2>
                    {/* 表示位置の高さをそろえるため。CSSの関係で追加している要素で動作はしない */}
                    <form id="queryForm" name="queryForm"> </form>
                    <h4 className="mod-hdg-l4-02">
                        お問い合わせ情報
                    </h4>
                    <div className="mod-tbl-form">
                        <table role="presentation">
                            <colgroup>
                                <col className="w-35" />
                                <col />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>受付番号</b>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="hidden" name="receipt_num_hidden" value="" />
                                        <div className="mod-input" id="receipt_num">
                                            {location.state.acceptanceNumber ? location.state.acceptanceNumber : acceptanceNumber}

                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>お問い合わせ状況</b>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="hidden" name="inquiry_state_hidden" value="" />
                                        <div className="mod-input" id="inquiry_state">
                                            {location.state.customerStatus ? location.state.customerStatus : customerStatus}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <h4 className="mod-hdg-l4-02">
                        お問い合わせ内容
                    </h4>

                    <div className="mod-tbl-form">
                        <table role="presentation">
                            <colgroup>
                                <col className="w-35" />
                                <col />
                            </colgroup>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>件名</b>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="hidden" name="title_hidden" value="" />
                                        <div className="mod-input" id="title">
                                            {location.state.subject ? location.state.subject : subject}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>運用形態</b>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="hidden" name="ope_form_hidden" value="" />
                                        <div className="mod-input" id="ope_form">
                                            {location.state.operationType ? location.state.operationType : operationType}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>お客様名(エンドユーザ様名)</b>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="hidden" name="end_user_hidden" value="" />
                                        <div className="mod-input" id="end_user">
                                            {location.state.customerName ? location.state.customerName : customerName}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                        </table>
                    </div>

                    <h4 className="mod-hdg-l4-02">
                        お問い合わせの更新
                    </h4>

                    <div className="mod-tbl-form">
                        <table role="presentation">
                            <colgroup>
                                <col className="w-35" />
                                <col />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>お問い合わせ区分<span className="required">必須</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mod-input-radio">
                                            <ul className="list">
                                                <li>
                                                    <label>
                                                        <input type="radio" id="inquiry_category1" name="re_inquiry_id" value="0" checked={inquiryCategory === "0"} onChange={handleInquiryCategoryChange} /><span
                                                            className="label">追加質問</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label>
                                                        <input type="radio" id="inquiry_category2" name="re_inquiry_id" value="1" checked={inquiryCategory === "1"} onChange={handleInquiryCategoryChange} /><span
                                                            className="label">情報提供</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label>
                                                        <input type="radio" id="inquiry_category3" name="re_inquiry_id" value="2" checked={inquiryCategory === "2"} onChange={handleInquiryCategoryChange} /><span
                                                            className="label">再確認</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label>
                                                        <input type="radio" id="inquiry_category4" name="re_inquiry_id" value="3" checked={inquiryCategory === "3"} onChange={handleInquiryCategoryChange} /><span
                                                            className="label">進捗確認</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label>
                                                        <input type="radio" id="inquiry_category5" name="re_inquiry_id" value="4" checked={inquiryCategory === "4"} onChange={handleInquiryCategoryChange} /><span
                                                            className="label">クローズ</span>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>更新内容<span className="required">必須</span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <ul className="list">
                                            <li>
                                                <div className="mod-input">
                                                    <p className="description">お問い合わせの内容をご入力ください。</p>
                                                    <p className="description">お問い合わせの内容について、特定のセキュリティ上のリスクを伴う文字・表現が含まれている場合は次ページの確認画面にてエラーとなる可能性がございます。</p>
                                                    <p className="description">詳細は以下の「注意事項」をご参照ください。</p>
                                                    <div className="description">
                                                        <b className="label" style={{ display: "inline-block", marginRight: "10px" }}>
                                                            <span style={{ cursor: "pointer" }} onClick={() => { setOpenAttentionDialog({ show: true, dialogId: "attention" }); }}>
                                                                <img src={imageUrlPopUp} alt="popup" className="icn" lang="en" />
                                                                <span >注意事項</span>
                                                            </span>
                                                        </b>

                                                    </div>
                                                    {openAttentionDialog.show &&
                                                        <AttentionDialog
                                                            open={openAttentionDialog.show}
                                                            onClose={handleClose}
                                                            name={"注意事項"}
                                                        />}
                                                    <textarea style={{ resize: "none" }} wrap="hard" rows="10" id="inquiry_contents"
                                                        name="question" maxLength="1500" value={questionArea} onChange={handleQuestionAreaChange}></textarea>
                                                </div>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b><span id="file" htmlFor="section">添付ファイル有無<span className="required">必須</span></span></b>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="mod-input-radio">
                                            <ul className="list">
                                                <li>
                                                    <label>
                                                        <input type="radio" id="no_attached" name="attached_file" value="0" checked={attachedFile === "0"} onChange={handleAttachedFileChange} /><span
                                                            className="label">なし</span>
                                                    </label>
                                                </li>
                                                <li>
                                                    <label>
                                                        <input type="radio" id="attached" name="attached_file" value="1" checked={attachedFile === "1"} onChange={handleAttachedFileChange} /><span
                                                            className="label">あり</span>
                                                    </label>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <h4 className="mod-hdg-l4-02">
                            マイナンバーの確認
                        </h4>

                        <div className="mod-txt">
                            <p>当センターでは、個人番号(マイナンバー)が含まれない情報の範囲で対応させていただきます。</p>
                            <p><em>恐れ入りますが、お問い合わせ内容および添付資料を再度ご確認いただき、以下をチェックしてください。</em></p>
                        </div>

                        <br />

                        <div className="mod-input-check">
                            <ul className="list">
                                <li><label>
                                    <input type="checkbox" id="mynumber" name="mynumber" onChange={handleCheckBoxChange} />
                                    <span className="label">お問い合わせ内容および添付資料にマイナンバーは含まれません。</span>
                                </label></li>
                            </ul>
                        </div>

                        <div className="mod-btn of-list">
                            <div className="btn">
                                <button id="btn-go-top" className="of-left" onClick={goBack}>トップページへ</button>
                            </div>
                            <div className="btn">
                                <button type="button" id="btn-send" className="btn_default_select" form="queryForm"
                                    onClick={toSend}>登録内容で送信する</button>
                            </div>
                        </div>

                    </div>

                    <h4 className="mod-hdg-l4-02">
                        お問い合わせ履歴
                    </h4>
                    <InqHistList />

                    <h4 className="mod-hdg-l4-02">
                        お問い合わせ製品情報
                    </h4>

                    <div id="inquiry_product" className="mod-tbl-form">
                        <table role="presentation">
                            <colgroup>
                                <col className="w-35" />
                                <col />
                            </colgroup>

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>本体</b>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="hidden" name="model_name_hidden" value="" />
                                        <div className="mod-input" id="model_name">
                                            {location.state.modelName ? location.state.modelName : modelName}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            {modelName || location.state.modelNumber ? (<tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>型番</b>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="hidden" name="model_num_hidden" value="" />
                                        <div className="mod-input" id="model_num">
                                            {location.state.modelNumber ? location.state.modelNumber : modelNumber}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>) : null}

                            <tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>OS</b>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="hidden" name="os_name_hidden" value="" />
                                        <div className="mod-input" id="os_name">
                                            {location.state.osName ? location.state.osName : osName}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>

                            {osName || location.state.osName ? (<tbody>
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>OSバージョン</b>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="hidden" name="os_ver_hidden" value="" />
                                        <div className="mod-input" id="os_ver">
                                            {location.state.osVersion ? location.state.osVersion : osVersion}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>) : null}

                            {relatedHardware1 || location.state.relatedHardware1 ? (<tbody id="hw_name1_body">
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>関連ハードウェア1</b>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="hidden" name="related_hw_hidden" value="" />
                                        <div className="mod-input" id="related_hw_id">
                                            {location.state.relatedHardware1 ? location.state.relatedHardware1 : relatedHardware1}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>) : null}

                            {relatedHardware1 || location.state.relatedHardware1 ? (<tbody id="hw_model1_body">
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>関連ハードウェア型番1</b>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="hidden" name="related_hw_num_hidden" value="" />
                                        <div className="mod-input" id="related_hw_num">
                                            {location.state.relatedHardwareModelNumber1 ? location.state.relatedHardwareModelNumber1 : relatedHardwareModelNumber1}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>) : null}

                            {relatedHardware2 || location.state.relatedHardware2 ? (<tbody id="hw_name2_body">
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>関連ハードウェア2</b>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="hidden" name="related_hw_hidden" value="" />
                                        <div className="mod-input" id="related_hw_id">
                                            {location.state.relatedHardware2 ? location.state.relatedHardware2 : relatedHardware2}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>) : null}

                            {relatedHardware2 || location.state.relatedHardware2 ? (<tbody id="hw_model2_body">
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>関連ハードウェア型番2</b>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="hidden" name="related_hw_num_hidden" value="" />
                                        <div className="mod-input" id="related_hw_num">
                                            {location.state.relatedHardwareModelNumber2 ? location.state.relatedHardwareModelNumber2 : relatedHardwareModelNumber2}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>) : null}

                            {relatedSoftware || location.state.relatedSoftware ? (<tbody id="sw_name_body">
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>関連ソフトウェア</b>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="hidden" name="related_sw_hidden" value="" />
                                        <div className="mod-input" id="related_sw_id">
                                            {location.state.relatedSoftware ? location.state.relatedSoftware : relatedSoftware}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>) : null}

                            {relatedSoftware || location.state.relatedSoftware ? (<tbody id="sw_model_body">
                                <tr>
                                    <td className="caption">
                                        <div className="inner">
                                            <b>関連ソフトウェア型番</b>
                                        </div>
                                    </td>
                                    <td>
                                        <input type="hidden" name="related_sw_num_hidden" value="" />
                                        <div className="mod-input" id="related_sw_num">
                                            {location.state.relatedSoftwareModelNumber ? location.state.relatedSoftwareModelNumber : relatedSoftwareModelNumber}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>) : null}
                        </table>
                    </div>



                    <div className="mod-btn of-list">
                        <div className="btn">
                            <button type="button" id="btn-go-top" className="of-left" onClick={goBack}>トップページへ</button>
                        </div>
                        <div className="btn">
                            <button type="button" id="btn-send" className="btn_default_select"
                                onClick={toSend}>登録内容で送信する</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default MainComponent;
